import { render, staticRenderFns } from "./BarConsultationsISTByOrigine.vue?vue&type=template&id=8d351a8a&"
import script from "./BarConsultationsISTByOrigine.vue?vue&type=script&lang=ts&"
export * from "./BarConsultationsISTByOrigine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports